"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isClazz = void 0;
function isClazz(value) {
    return ["ClazzNull", "ClazzCons", "ClazzFulfilled"].includes(value["@kind"]);
}
exports.isClazz = isClazz;
//# sourceMappingURL=isClazz.js.map